// Shared package-identity context.
//
// Lives outside the report route so presentation components (chapter chrome,
// section intros) can read the active package identity without importing the
// route module. The report route re-exports these so existing call sites stay
// unchanged.

import { createContext, useContext } from "react";
import {
  getPackageIdentity,
  type PackageIdentity,
} from "@/lib/report/package-identity";

export const PdfPackageContext = createContext<PackageIdentity>(
  getPackageIdentity("complete"),
);

export function usePdfPackageIdentity(): PackageIdentity {
  return useContext(PdfPackageContext);
}
